module.exports = __webpack_public_path__ + "img/road.dfe4c447.png";